import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerLowSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998V3.911l-1.627 1.308-5.058 4.066H3.001v6.288h3.372l5.085 3.27 1.541.992V5.998Zm2.319 2.896.815.579c.248.176.47.39.656.632 1.093 1.403.772 3.388-.647 4.421l-.809.589-1.177-1.617.809-.589c.534-.389.623-1.093.245-1.576l-.007-.01a1.07 1.07 0 0 0-.23-.22l-.814-.58 1.159-1.63Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerLowSharpFill);
export default Memo;
